import { motion } from "framer-motion";

const SlideIn = ({
  children,
  delay = 0,
  triggerOnView = false,
  manualStart = false,
  start = false,
  className = "",
}) => {
  const variants = {
    hidden: { opacity: 0, x: -120 },
    visible: { opacity: 1, x: 0 },
  };

  // If manualStart is true, animate depends on `start` prop
  // Else if triggerOnView is true, use viewport + whileInView
  // Else animate immediately (controlled by delay only)

  if (manualStart) {
    return (
      <div className="w-full h-full absolute overflow-visible">
        <motion.div
          variants={variants}
          initial="hidden"
          animate={start ? "visible" : "hidden"}
          transition={{ duration: 0.75, ease: "easeOut", delay }}
        >
          {children}
        </motion.div>
      </div>
    );
  }

  if (triggerOnView) {
    return (
      <div className="w-full h-full absolute overflow-visible">
        <motion.div
          variants={variants}
          initial="hidden"
          whileInView="visible"
          viewport={{ once: true, amount: 0.5 }}
          transition={{ duration: 0.75, ease: "easeOut", delay }}
        >
          {children}
        </motion.div>
      </div>
    );
  }

  // Default immediate animate (with delay)
  return (
    <div className="w-full h-full absolute overflow-visible">
      <motion.div
        variants={variants}
        initial="hidden"
        animate="visible"
        transition={{ duration: 0.75, ease: "easeOut", delay }}
      >
        {children}
      </motion.div>
    </div>
  );
};

export default SlideIn;
